import React from "react";
import styles from "../../../../assets/styles/componentStyles/templateLibraryStyles/whatsappTemplatePreview.module.scss";
import { replacingTemplateMarkdownText } from "../../../../utils/constants";

export type VariableDataItem = {
    whatsapp_template_dynamic_variable_key: string;
    whatsapp_template_dynamic_variable_sample_value?: string;
    [key: string]: any;
};

function escapeHtml(str: string): string {
    return str
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

function escapeRegex(str: string): string {
    return str?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

type VariableDisplayMeta = {
    sampleText: string;
    keyText: string;
};

export function renderVariableInText(
    text: string,
    variableData: VariableDataItem[] | undefined,
): React.ReactElement {
    
    const rawText = text || "";
    const keyToDisplayText = new Map<string, VariableDisplayMeta>();

    if (variableData?.length) {
        variableData?.forEach((variable) => {
            const key = variable?.whatsapp_template_dynamic_variable_key;
            if (!key) return;
            const sampleValue = variable?.whatsapp_template_dynamic_variable_sample_value;
            const hasSampleText = sampleValue != null && String(sampleValue).trim() !== "";
            const displayText = hasSampleText
                ? escapeHtml(String(sampleValue))
                : key;

            keyToDisplayText.set(key, {
                sampleText: displayText?.trim() !== "" ? displayText : key,
                keyText: key,
            });
        });
    }

    const keys = Array.from(keyToDisplayText?.keys()).sort((a, b) => b?.length - a?.length);
    if (keys.length === 0) {
        return (
            <span
                className={styles.whatsappPreview__textContentPreview}
                dangerouslySetInnerHTML={{
                    __html: replacingTemplateMarkdownText(rawText),
                }}
            />
        );
    }

    const pattern = new RegExp(
        `(${keys.map(escapeRegex).join("|")})`,
        "g"
    );
    const segments = rawText?.split(pattern)?.filter(Boolean);

    return (
        <>
            <span className={styles.whatsappPreview__textContentPreview}>
                {segments.map((segment, i) => {
                    const displayText = keyToDisplayText?.get(segment);
                    if (displayText) {
                        return (
                            <span
                                key={i}
                                className={styles.whatsappPreview__variable}
                                data-variable="true"
                                data-variable-key={displayText?.keyText}
                            >
                                <span className={styles.whatsappPreview__variableSample}>
                                    {displayText?.sampleText}
                                </span>
                                <span className={styles.whatsappPreview__variableKey}>
                                    {displayText?.keyText}
                                </span>
                            </span>
                        );
                    }
                    return (
                        <span
                            key={i}
                            dangerouslySetInnerHTML={{
                                __html: replacingTemplateMarkdownText(segment),
                            }}
                        />
                    );
                })}
            </span>
        </>
    );
}
